module.exports = __webpack_public_path__ + "img/ty2.0f1ac917.png";